import { render, staticRenderFns } from "./MilestoneDetails.vue?vue&type=template&id=4ff7a701&"
import script from "./MilestoneDetails.vue?vue&type=script&lang=js&"
export * from "./MilestoneDetails.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneDetails.vue?vue&type=style&index=0&id=4ff7a701&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports